import React, { useState } from 'react'
import Projects from './Projects';
import Flowchart from './Flowchart';

function ProjectsDescription() {
    const [activeTab, setActiveTab] = useState(1)

    const handleClickTab = (tabIndex) => {
        setActiveTab(tabIndex);
      };
      
      const getButtonStyles = (tabIndex) => {
        return activeTab === tabIndex
          ? 'bg-black text-white' // Active button styles ( black background and white text)
          : 'bg-[#202020] text-white'; // Inactive button styles (gray background and white text)
      };


  return (

    
    <div className="w-full h-full flex flex-col md:flex-row lg:items-center my-5 lg:my-10 lg:px-10 ">

      <div className="w-full md:w-[60%] flex flex-col items-center my-8  md:mr-12 lg:mx-[7%]">
       <h1 className="text-white font-bold font-nunito text-2xl md:text-3xl mb-5"> 
       Easily apply for jobs by engaging in projects curated just for you.</h1>
       <p className="text-white md:text-xl font-nunito font-medium indent-4">
       Our platform recognizes when something needs to be changed. 
       By pinpointing problem areas, projects are created to tackle big problems, 
       paving the way for jobs and community action. Looking for a way to help? We try our best 
       to match you with projects that you may find interesting, and from there, we make 
       it easy for you to apply for an open position or simply contribute through your thoughts or donations.
       </p>
      </div>

      <div className="w-full md:w-[40%] h-[300px] overflow-y-scroll scroll-bar-in-dark">
          <div className='sticky top-0 w-full z-[2] flex justify-between items-center'>
            <button
              className={`${getButtonStyles(1)} px-4 py-2 w-2/4 rounded-tl-lg`} 
              onClick={() => handleClickTab(1)}
            >
              <span className='font-nunito text-[10px] md:text-sm md:font-bold'>Project</span>
            </button>
            <button
              className={`${getButtonStyles(2)} px-4 py-2 w-2/4 rounded-tr-lg`} 
              onClick={() => handleClickTab(2)}
            >
              <span className='font-nunito text-[10px] md:text-sm md:font-bold '>FlowChart</span>
            </button>
          </div>

          <div className='p-5  bg-black h-full'>
          {activeTab === 1 && <div><Projects/></div>}
          {activeTab === 2 && <div><Flowchart/></div>}
          </div>
      </div>
    </div>


  )
}

export default ProjectsDescription
